/* sk-quiz.js v2 — The Shredded Kitchen quiz engine
   4 routes: box / oneoff / coaching / custom
   Email capture: real Shopify customer + tags (synced to MailChimp by the
     Mailchimp Shopify app) via the hidden {% form 'customer' %} in
     sk-quiz-body.liquid — see skLeadCapture(). Same mechanism as the homepage
     (sk-newsletter) and footer signup forms.
   Analytics: kTrack() still pushes to Klaviyo's _learnq queue, but Klaviyo's
     onsite JS is NOT installed, so those are dormant no-ops kept for an easy
     future swap to GA4/MailChimp events. They DO NOT capture email — capture is
     skLeadCapture() only.
   Popup: scroll-past-plans (homepage only), exit-intent, sessionStorage dismiss
*/

/* ─── ANALYTICS (dormant _learnq queue — see header) ────── */
function kTrack(e, p) {
  try {
    var _learnq = window._learnq || [];
    _learnq.push(['track', e, p || {}]);
  } catch (x) {}
}

/* ─── LEAD CAPTURE → Shopify customer + tags (→ MailChimp) ──────────────────
   Submits the hidden Shopify {% form 'customer' %} (#sk-lead-form in
   sk-quiz-body.liquid) in the background via fetch, so a quiz email becomes a
   REAL Shopify customer with the given tags — exactly like the homepage/footer
   signup forms. Shopify rendered the form's action + form_type/utf8 hidden
   inputs, so we only set the email + tags and post the whole form.
   Fire-and-forget: the email is already validated client-side and we show our
   own success, so a failed or duplicate-customer POST never blocks the UI. */
/* Mailchimp lead capture — email + intent tags only. The mobile number deliberately
   does NOT come through here: it goes to the kitchen inbox via skNotifyKitchen, not
   into marketing (owner decision 2026-08-13). */
function skLeadCapture(email, tags, tier) {
  email = (email || '').trim();
  if (!email) return;
  tags = tags || 'quiz,newsletter';
  tier = tier || '';
  /* server-side CAPI (QuizComplete) — returns the event_id reused by the browser pixel for dedup.
     Email is hashed in n8n; the dataLayer push below carries NO email/PII. */
  var skQcId = window.skMetaCapi ? window.skMetaCapi('QuizComplete', { email: email, tags: tags }) : '';
  /* dataLayer: quiz_complete -> GTM -> GA4 + Meta browser pixel (same event_id -> dedup; NO email/PII pushed) */
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'quiz_complete', quiz_tags: (tags || '').toString(), event_id: skQcId });
  /* 1) intent tags → Mailchimp via the n8n bridge, so tag-triggered automations fire
     instantly (ShopSync + the SK CRM don't carry signup tags across — see
     snippets/sk-signup-bridge.liquid). */
  if (window.skMailchimpSignup) { window.skMailchimpSignup(email, tags, tier); }
  /* 2) also create a real Shopify customer via the hidden {% form 'customer' %}, so the
     person enters the SK CRM / Notion as a lead (same as the homepage/footer forms). */
  var form = document.getElementById('sk-lead-form');
  var emailInput = document.getElementById('sk-lead-email');
  var tagsInput = document.getElementById('sk-lead-tags');
  if (!form || !emailInput) return;
  emailInput.value = email;
  if (tagsInput) tagsInput.value = tags;
  try {
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form)
    }).catch(function () {});
  } catch (x) {}
}

/* ─── KITCHEN NOTIFY → n8n → info@ email ─────────────────────
   The lead capture above is silent (Shopify customer + tags only) — nobody at
   SK gets told. This is the part that actually lands in the inbox, so the
   "Send to Kieran" promise is real. Fire-and-forget with keepalive so it
   survives the swap to the success screen; a failure never blocks the UI
   (the lead is still captured in Shopify either way). */
function skNotifyKitchen(fields) {
  try {
    var fd = new FormData();
    Object.keys(fields).forEach(function (k) { if (fields[k]) fd.append(k, fields[k]); });
    fd.append('Page', location.href);
    fetch('https://n8n.srv1085988.hstgr.cloud/webhook/sk-quiz-coaching', { method: 'POST', body: fd, keepalive: true }).catch(function () {});
  } catch (x) {}
}

/* ─── CONFIG ────────────────────────────────────────────── */
var SK_EXIT_INTENT = true;
/* Box result CTA adds to cart then sends the user to the cart page.
   false = one-time purchase (cart price matches the result table).
   true  = weekly subscription (10% off) via the Recharge selling plan. */
var SK_BOX_AS_SUBSCRIPTION = false;

/* Relative URL destinations */
var SK_URL = {
  box:    '/products/the-weekly-box',
  oneoff: '/collections/og-chefs-selection-single-meals',
  custom: '/pages/custom-plan',
  contact:'/pages/contact'
};

/* ─── ROUTER (Q1) ────────────────────────────────────────── */
var SK_ROUTER = {
  text: 'How do you want your meals handled?',
  sub:  "We're the meal part: chef made and delivered. The only question is how much of it you'd like us to take off your hands.",
  opts: [
    { label: 'Just sort it for me.',                                  echo: 'You want it sorted for you.',                  branch: 'box' },
    { label: "I'll cook, I just need a plan that actually works.",   echo: "You'll cook, you just need a plan that works.", branch: 'coaching' },
    { label: 'Let me try first. No commitment.',                      echo: 'You want to try first, no commitment.',        branch: 'oneoff' }
  ]
};

/* ─── BOX Q2: tier ───────────────────────────────────────── */
var SK_TIER = {
  text: 'What are you really after?',
  opts: [
    { label: 'I just want to eat well without thinking about it.',   echo: 'You want good food, sorted, no fuss.',           tier: 'lifestyle' },
    { label: 'I train hard and need food that supports it.',          echo: 'You train hard and need food that supports it.', tier: 'performance' },
    { label: 'I eat fewer meals, so each one needs max protein.',     echo: 'You eat fewer meals, so each one has to count.', tier: 'recovery' },
    { label: "My situation's more specific than that.",              echo: "Your situation's a bit more specific.",           tier: 'custom' }
  ]
};

/* ─── BOX Q3: size ───────────────────────────────────────── */
var SK_SIZE = {
  text: 'How much of your week do you want handled?',
  opts: [
    { label: '5 meals, a few to take the pressure off.',  echo: 'You want a few meals to take the pressure off.', size: 5 },
    { label: '10 meals, most of my week sorted.',         echo: 'You want most of your week sorted.',             size: 10 },
    { label: '15 meals, the whole week handled.',         echo: "You're ready to hand over the whole week.",      size: 15 }
  ]
};

/* ─── DIETARY chips ──────────────────────────────────────── */
/* This is only a FALLBACK. The real list comes from the single source of truth —
   the `sk_allergen_list` theme setting — injected via the JSON island and applied
   to SK_DIET in the island reader below. The cart-extras card, Weekly Box and
   intake form read the same setting, so they can't drift. Do NOT hand-edit this
   array to change the chips; edit Theme Settings → Allergens (SK) instead.
   Non-allergen preferences (no chicken/pork, etc.) go in the free-text box. */
var SK_DIET = ['Gluten', 'Dairy', 'Egg', 'Peanuts', 'Tree nuts', 'Fish', 'Shellfish'];

/* ─── SIZE VALUE — time-back reframe ────────────────────── */
var SK_SIZEVAL = {
  5:  { hrs: 'about 2 hours',   hrsShort: '2 hrs',  grocery: '$80–110' },
  10: { hrs: 'around 3½ hours', hrsShort: '3½ hrs', grocery: '$140–180' },
  15: { hrs: 'a good 5 hours',  hrsShort: '5 hrs',  grocery: '$190–230' }
};

/* ─── COACHING FORM (steps 1-3 + email added) ────────────── */
var SK_CF = [
  { key: 'outcome', q: "What's the outcome you actually want?",     type: 'textarea', ph: 'Where you want to get to…' },
  { key: 'blocker', q: "What's stopped you getting there so far?",  type: 'textarea', ph: 'Be honest, it helps Kieran help you…' },
  { key: 'timing',  q: 'When are you ready to start?',              type: 'choice',   opts: ['This week', 'This month', 'Just exploring'] }
];

/* ─── BOX TIER RESULTS ───────────────────────────────────── */
var SK_TIERS = {
  lifestyle: {
    badge:   'Lifestyle Plan',
    title:   'Your match: the <em>Lifestyle</em> Weekly Box.',
    desc:    "Healthy, balanced food that's ready when you are, without it becoming another thing to think about. New menu every week.",
    macros:  '350–450 cal · balanced macros, everyday eating',
    diag:    '<strong>Wanting to eat well and never quite making it stick isn\'t willpower, it\'s the setup.</strong> When good food is already in the fridge, the decision\'s made for you.',
    rows:    [
      { size: 5,  wk: '$95',  pm: '$19.00' },
      { size: 10, wk: '$185', pm: '$18.50' },
      { size: 15, wk: '$265', pm: '$17.67' }
    ],
    reframe: 'Cooking it yourself runs about $150–200/week on groceries plus ~5 hours of shopping, prep and cleanup, before the mental load of deciding what to make.'
  },
  performance: {
    badge:   'Performance Plan',
    title:   'Your match: the <em>Performance</em> Weekly Box.',
    desc:    'You train hard and your food needs to match. Performance is built for people who burn it in the gym, on the field, or in a physical job.',
    macros:  '500–650 cal · higher carbs for training days',
    diag:    '<strong>Training hard on food that doesn\'t match is how progress stalls. The work\'s there, the nutrition isn\'t.</strong> Every week you wing it is a week your results sit still.',
    rows:    [
      { size: 5,  wk: '$103', pm: '$20.60' },
      { size: 10, wk: '$195', pm: '$19.50' },
      { size: 15, wk: '$289', pm: '$19.27' }
    ],
    reframe: 'Cooking it yourself runs about $150–200/week plus ~5 hours of prep, and that\'s without hitting your carb targets consistently, session after session.'
  },
  recovery: {
    badge:   'Recovery Plan',
    title:   'Your match: the <em>Recovery</em> Weekly Box.',
    desc:    'You eat fewer meals, but each one has to work hard. Recovery is built for building muscle, real satiety, and serious results.',
    macros:  '570–670 cal · higher protein for recovery',
    diag:    '<strong>Running on empty doesn\'t stay quiet. It shows up as the 3pm crash and the meals you skip then make up for badly at night.</strong> Each meal has to earn its place.',
    rows:    [
      { size: 5,  wk: '$110', pm: '$22.00' },
      { size: 10, wk: '$215', pm: '$21.50' },
      { size: 15, wk: '$310', pm: '$20.67' }
    ],
    reframe: 'Cooking it yourself runs about $150–200/week plus ~5 hours of prep, and hitting 55g protein from scratch, every single meal, is a mission in itself.'
  },
  custom: {
    badge:   'Custom Plan',
    title:   'You need a <em>Custom</em> plan.',
    desc:    'Your goals or situation go beyond a standard tier, which is exactly what custom cooking is for. We\'ll build your meals to match whatever plan you\'re on.',
    macros:  'Built to your exact macros, portions & requirements',
    diag:    "<strong>A standard tier won't quite fit you, and forcing it would just be another compromise.</strong> Better to build it right around what you actually need.",
    rows:    null,
    reframe: "Already have a plan from a coach? Send it over and we'll quote you, free. No plan yet? We'll build one and cook it: a complete, done-for-you solution."
  }
};

/* ─── STATE ──────────────────────────────────────────────── */
var skBranch = null;
var skScreen = 'router';
var skAns = { router: null, tier: null, size: null, diet: [], dietText: '', cf: { outcome: '', blocker: '', timing: null, email: '', phone: '' }, cx: { need: '', plan: null, email: '', phone: '' } };
var skCfIndex = 0;
var skGift = false;  /* free-pot first-box offer retired 2026-07-08 — gift UI removed; downstream stash/add code is dormant while false */
var skSessionShown = false;
var SK_DISMISS_KEY = 'sk_quiz_dismissed';
var skLastFocus = null;   /* element to restore focus to when the popup closes */

var SK_SEQ = { box: ['router', 'tier', 'size', 'dietary'], oneoff: ['router', 'dietary'], coaching: ['cf1', 'cf2', 'cf3'] };

/* ─── HELPERS ────────────────────────────────────────────── */
function skShowScreen(id) {
  document.querySelectorAll('.sk-screen').forEach(function (s) { s.classList.remove('active'); });
  var el = document.getElementById(id);
  if (!el) return;
  el.classList.add('active');
  var h = el.querySelector('[tabindex="-1"]');
  if (h) { setTimeout(function () { h.focus({ preventScroll: true }); }, 60); }
  /* scroll popup to top if inside a popup */
  var popup = document.getElementById('sk-quiz-popup');
  if (popup) popup.scrollTop = 0;
}

function checkSVG() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg>';
}
function xSVG() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
}
function arrowSVG() {
  return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
}

/* ─── FIELD VALIDATION FEEDBACK ──────────────────────────────
   Show an inline error that's announced to screen readers (role="alert") and
   marked with a RED border — never green (green reads as success). `anchor` is
   the element the message is inserted after (defaults to the input itself); pass
   a different anchor to keep the message out of a flex row. */
function skFieldError(input, msg, anchor) {
  if (!input) return;
  input.setAttribute('aria-invalid', 'true');
  input.style.borderColor = 'var(--red, #c0392b)';
  anchor = anchor || input;
  var err = anchor.parentNode.querySelector('.sk-field-err');
  if (!err) {
    err = document.createElement('div');
    err.className = 'sk-field-err';
    err.setAttribute('role', 'alert');
    err.style.cssText = 'color:var(--red,#c0392b);font-size:13px;line-height:1.4;margin-top:8px;';
    anchor.parentNode.insertBefore(err, anchor.nextSibling);
  }
  err.textContent = msg;
  input.focus();
}
function skFieldClear(input) {
  if (!input) return;
  input.removeAttribute('aria-invalid');
  input.style.borderColor = '';
  var holder = input.closest('.sk-screen') || input.parentNode;
  var err = holder ? holder.querySelector('.sk-field-err') : null;
  if (err) err.textContent = '';
}
function skValidEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
}

/* Mobile number — every quiz branch that collects contact details requires one
   (owner requirement, 2026-08-13). The canonical helpers live site-wide in
   snippets/sk-signup-bridge.liquid; these thin wrappers fall back to the same rules
   so the quiz still validates if it's ever rendered without the bridge. Named
   skQuiz* deliberately: sk-quiz.js declares globals, so reusing the bridge's names
   would overwrite them and recurse. */
function skQuizValidPhone(v) {
  if (window.skValidPhone) return window.skValidPhone(v);
  var digits = (v || '').replace(/\D/g, '');
  return digits.length >= 8 && digits.length <= 15;
}
function skQuizPhoneE164(v) {
  return window.skNormalisePhone ? window.skNormalisePhone(v) : (v || '').trim();
}

function skCounter(screenKey) {
  var seq = SK_SEQ[skBranch || 'box'];
  var idx = seq.indexOf(screenKey);
  if (idx === -1) { idx = 0; }
  var n = seq.length;
  var i = idx + 1;
  return { i: i, n: n, pct: Math.round((i / n) * 100) };
}

/* ─── SINGLE-SELECT QUIZ (router / tier / size) ──────────── */
function skRenderQuiz() {
  var data, screenKey, tag = '';
  if (skScreen === 'router') { data = SK_ROUTER; screenKey = 'router'; tag = 'Step 1 of your route'; }
  else if (skScreen === 'tier') { data = SK_TIER; screenKey = 'tier'; tag = 'The Weekly Box'; }
  else if (skScreen === 'size') { data = SK_SIZE; screenKey = 'size'; tag = 'The Weekly Box'; }

  var c = skCounter(screenKey);
  /* On the router the branch isn't chosen yet, so the total ("of N") is unknown —
     show a neutral label instead of the misleading box-default "1 of 4". */
  if (screenKey === 'router') {
    document.getElementById('sk-q-counter').textContent = 'Question 1';
    document.getElementById('sk-q-pct').textContent = '';
    document.getElementById('sk-prog').style.width = '12%';
  } else {
    document.getElementById('sk-q-counter').textContent = c.i + ' of ' + c.n;
    document.getElementById('sk-q-pct').textContent = c.pct + '%';
    document.getElementById('sk-prog').style.width = c.pct + '%';
  }
  document.getElementById('sk-q-tag').textContent = tag;
  document.getElementById('sk-q-text').textContent = data.text;
  var subEl = document.getElementById('sk-q-sub');
  subEl.textContent = data.sub || '';

  document.getElementById('sk-btn-back').classList.toggle('hide', skScreen === 'router');

  var wrap = document.getElementById('sk-opts');
  wrap.innerHTML = '';
  data.opts.forEach(function (o, i) {
    var selected = false;
    if (screenKey === 'tier') selected = (skAns.tier === o.tier);
    else if (screenKey === 'size') selected = (skAns.size === o.size);
    else selected = (skAns.router === i);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sk-opt' + (selected ? ' selected' : '');
    b.innerHTML = '<span class="sk-opt-txt">' + o.label + '</span><span class="sk-check">' + checkSVG() + '</span>';
    b.onclick = (function (opt, idx) {
      return function () { skPickQuiz(screenKey, opt, idx); };
    })(o, i);
    wrap.appendChild(b);
  });

  skShowScreen('sk-s-quiz');
}

function skPickQuiz(screenKey, opt, idx) {
  document.querySelectorAll('#sk-opts .sk-opt').forEach(function (b, j) {
    b.classList.toggle('selected', j === idx);
  });

  if (screenKey === 'router') {
    skAns.router = idx; skBranch = opt.branch; skAns.routerEcho = opt.echo;
    kTrack('quiz_branch', { branch: skBranch });
    kTrack('quiz_answer', { question: 'router', answer: opt.label });
    setTimeout(function () {
      if (skBranch === 'box') { skScreen = 'tier'; skRenderQuiz(); }
      else if (skBranch === 'oneoff') { skScreen = 'dietary'; skRenderDietary(); }
      else { skCfIndex = 0; skRenderCoach(); }
    }, 250);
  } else if (screenKey === 'tier') {
    skAns.tier = opt.tier; skAns.tierEcho = opt.echo;
    kTrack('quiz_answer', { question: 'tier', answer: opt.tier });
    /* custom goes straight to the full intake page — the in-popup cx mini form is bypassed */
    if (opt.tier === 'custom') { setTimeout(function () { window.location.href = SK_URL.custom; }, 250); }
    else { setTimeout(function () { skScreen = 'size'; skRenderQuiz(); }, 250); }
  } else if (screenKey === 'size') {
    skAns.size = opt.size; skAns.sizeEcho = opt.echo;
    kTrack('quiz_answer', { question: 'size', answer: opt.size });
    setTimeout(function () { skScreen = 'dietary'; skRenderDietary(); }, 250);
  }
}

function skQuizBack() {
  if (skScreen === 'tier') { skScreen = 'router'; skRenderQuiz(); }
  else if (skScreen === 'size') { skScreen = 'tier'; skRenderQuiz(); }
}

/* ─── DIETARY ─────────────────────────────────────────────── */
/* "None, I'm easy" is a destructive shortcut (it clears all picks). Only show it
   when nothing is selected, so it can never silently wipe a ticked allergen. Once
   the user has any chip or free-text, the primary "See my result" keeps their picks. */
function skUpdateDietNoneVisibility() {
  var none = document.getElementById('sk-diet-none');
  if (!none) return;
  var txt = document.getElementById('sk-diet-text');
  var hasText = txt && txt.value.trim().length > 0;
  var hasPicks = skAns.diet.length > 0 || hasText;
  none.style.display = hasPicks ? 'none' : '';
}
function skRenderDietary() {
  var c = skCounter('dietary');
  document.getElementById('sk-d-counter').textContent = c.i + ' of ' + c.n;
  document.getElementById('sk-d-pct').textContent = c.pct + '%';
  document.getElementById('sk-d-prog').style.width = c.pct + '%';

  var wrap = document.getElementById('sk-diet-chips');
  wrap.innerHTML = '';
  SK_DIET.forEach(function (label) {
    var on = skAns.diet.indexOf(label) > -1;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sk-chip' + (on ? ' selected' : '');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.innerHTML = '<span class="sk-tick">' + checkSVG() + '</span>' + label;
    b.onclick = (function (lbl, btn) {
      return function () {
        var isOn = btn.classList.toggle('selected');
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        if (isOn) { if (skAns.diet.indexOf(lbl) < 0) skAns.diet.push(lbl); }
        else { skAns.diet = skAns.diet.filter(function (d) { return d !== lbl; }); }
        skUpdateDietNoneVisibility();
      };
    })(label, b);
    wrap.appendChild(b);
  });
  var dietText = document.getElementById('sk-diet-text');
  dietText.value = skAns.dietText || '';
  dietText.oninput = function () { skAns.dietText = dietText.value; skUpdateDietNoneVisibility(); };
  skUpdateDietNoneVisibility();
  skShowScreen('sk-s-dietary');
}

function skDietBack() {
  if (skBranch === 'oneoff') { skScreen = 'router'; skRenderQuiz(); }
  else { skScreen = 'size'; skRenderQuiz(); }
}

/* ─── COACHING FORM ──────────────────────────────────────── */
function skRenderCoach() {
  var totalSteps = SK_CF.length + 1; /* +1 for email step */
  var stepNum = skCfIndex + 1;
  document.getElementById('sk-cf-counter').textContent = stepNum + ' of ' + totalSteps;
  var pct = Math.round((stepNum / totalSteps) * 100);
  document.getElementById('sk-cf-pct').textContent = pct + '%';
  document.getElementById('sk-cf-prog').style.width = pct + '%';

  var nextBtn = document.getElementById('sk-cf-next');

  /* Email step (last step, appended after SK_CF) */
  if (skCfIndex === SK_CF.length) {
    document.getElementById('sk-cf-q').textContent = 'Where can we reach you?';
    var box = document.getElementById('sk-cf-input');
    box.innerHTML = '';
    var inp = document.createElement('input');
    inp.type = 'email'; inp.inputMode = 'email'; inp.id = 'sk-cf-email';
    inp.className = 'sk-field'; inp.placeholder = 'you@email.com';
    inp.setAttribute('aria-label', 'Where can we reach you? Your email address');
    inp.value = skAns.cf.email || (window.skKnownEmail ? window.skKnownEmail() : '') || '';
    if (inp.value) skAns.cf.email = inp.value;
    inp.oninput = function () { skAns.cf.email = inp.value; skFieldClear(inp); };
    inp.onkeydown = function (e) { if (e.key === 'Enter') { e.preventDefault(); skCoachNext(); } };
    box.appendChild(inp);
    /* Mobile number is required here too — Kieran calls these leads back, so an
       email on its own isn't enough to action them. */
    var tel = document.createElement('input');
    tel.type = 'tel'; tel.inputMode = 'tel'; tel.id = 'sk-cf-phone';
    tel.className = 'sk-field sk-cf-phone'; tel.placeholder = '021 123 4567';
    tel.autocomplete = 'tel';
    tel.setAttribute('aria-label', 'Your mobile number');
    tel.value = skAns.cf.phone || '';
    tel.oninput = function () { skAns.cf.phone = tel.value; skFieldClear(tel); };
    tel.onkeydown = function (e) { if (e.key === 'Enter') { e.preventDefault(); skCoachNext(); } };
    box.appendChild(tel);
    nextBtn.style.display = 'inline-flex';
    nextBtn.innerHTML = 'Send to Kieran ' + arrowSVG();
    return;
  }

  var step = SK_CF[skCfIndex];
  document.getElementById('sk-cf-q').textContent = step.q;
  var cfBox = document.getElementById('sk-cf-input');
  cfBox.innerHTML = '';

  if (step.type === 'textarea') {
    var ta = document.createElement('textarea');
    ta.className = 'sk-field'; ta.placeholder = step.ph; ta.value = skAns.cf[step.key] || '';
    ta.setAttribute('aria-label', step.q);
    ta.oninput = function () { skAns.cf[step.key] = ta.value; };
    cfBox.appendChild(ta);
    nextBtn.style.display = 'inline-flex';
    nextBtn.innerHTML = 'Next ' + arrowSVG();
  } else {
    /* choice (timing) */
    var opts = document.createElement('div'); opts.className = 'sk-opts';
    step.opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sk-opt' + (skAns.cf.timing === o ? ' selected' : '');
      b.innerHTML = '<span class="sk-opt-txt">' + o + '</span><span class="sk-check">' + checkSVG() + '</span>';
      b.onclick = (function (val) {
        return function () {
          skAns.cf.timing = val;
          opts.querySelectorAll('.sk-opt').forEach(function (x) { x.classList.remove('selected'); });
          b.classList.add('selected');
          setTimeout(function () { skCfIndex++; skRenderCoach(); }, 260);
        };
      })(o);
      opts.appendChild(b);
    });
    cfBox.appendChild(opts);
    nextBtn.style.display = 'none';
  }
  skShowScreen('sk-s-coachform');
}

function skCoachNext() {
  var step = (skCfIndex < SK_CF.length) ? SK_CF[skCfIndex] : { type: 'email' };
  if (step.type === 'email') {
    /* email step — validate + submit */
    var email = (skAns.cf.email || '').trim();
    var inp = document.getElementById('sk-cf-email');
    if (inp) email = inp.value.trim();
    if (!skValidEmail(email)) {
      skFieldError(inp, 'Please enter a valid email so Kieran can reach you.');
      return;
    }
    skFieldClear(inp);
    skAns.cf.email = email;
    var tel = document.getElementById('sk-cf-phone');
    var phone = (tel ? tel.value : (skAns.cf.phone || '')).trim();
    if (!skQuizValidPhone(phone)) {
      skFieldError(tel, 'Please add your mobile number so Kieran can give you a call.');
      return;
    }
    skFieldClear(tel);
    skAns.cf.phone = phone;
    skSubmitCoaching();
    return;
  }
  if (step.type === 'textarea') {
    if (skCfIndex < SK_CF.length) { skCfIndex++; skRenderCoach(); }
  }
}

function skCoachBack() {
  if (skCfIndex > 0) { skCfIndex--; skRenderCoach(); }
  else { skScreen = 'router'; skRenderQuiz(); }
}

function skSubmitCoaching() {
  var email = skAns.cf.email || '';
  var phone = skAns.cf.phone || '';
  /* capture as a Shopify customer → MailChimp (quiz coaching lead) */
  skLeadCapture(email, 'quiz,coaching,newsletter');
  /* email the kitchen — this is the "Send to Kieran" part */
  skNotifyKitchen({ Email: email, Phone: skQuizPhoneE164(phone), Route: 'coaching', Outcome: skAns.cf.outcome, Blocker: skAns.cf.blocker, Timing: skAns.cf.timing });
  kTrack('quiz_coaching_submit', { timing: skAns.cf.timing || '', outcome: skAns.cf.outcome || '', email: email });
  skShowScreen('sk-s-coachdone');
}

/* ─── CUSTOM LEAD FORM ───────────────────────────────────── */
function skRenderCustom() {
  document.getElementById('sk-cx-need').value = skAns.cx.need || '';
  var cxEmail = document.getElementById('sk-cx-email');
  cxEmail.value = skAns.cx.email || (window.skKnownEmail ? window.skKnownEmail() : '') || '';
  cxEmail.oninput = function () { skFieldClear(cxEmail); };
  cxEmail.onkeydown = function (e) { if (e.key === 'Enter') { e.preventDefault(); skSubmitCustom(); } };
  var cxPhone = document.getElementById('sk-cx-phone');
  if (cxPhone) {
    cxPhone.value = skAns.cx.phone || '';
    cxPhone.oninput = function () { skFieldClear(cxPhone); };
    cxPhone.onkeydown = function (e) { if (e.key === 'Enter') { e.preventDefault(); skSubmitCustom(); } };
  }
  var planWrap = document.getElementById('sk-cx-plan');
  planWrap.querySelectorAll('.sk-opt').forEach(function (b) {
    var on = (b.getAttribute('data-v') === skAns.cx.plan);
    b.classList.toggle('selected', on);
    if (!b._wired) {
      b._wired = true;
      b.onclick = function () {
        skAns.cx.plan = b.getAttribute('data-v');
        planWrap.querySelectorAll('.sk-opt').forEach(function (x) { x.classList.remove('selected'); });
        b.classList.add('selected');
      };
    }
  });
  skShowScreen('sk-s-custom');
}

function skSubmitCustom() {
  var needEl = document.getElementById('sk-cx-need');
  var emailEl = document.getElementById('sk-cx-email');
  var phoneEl = document.getElementById('sk-cx-phone');
  skAns.cx.need = (needEl ? needEl.value : '').trim();
  skAns.cx.email = (emailEl ? emailEl.value : '').trim();
  skAns.cx.phone = (phoneEl ? phoneEl.value : '').trim();
  if (!skValidEmail(skAns.cx.email)) {
    skFieldError(emailEl, 'Please enter a valid email so we can send your quote.');
    return;
  }
  skFieldClear(emailEl);
  if (!skQuizValidPhone(skAns.cx.phone)) {
    skFieldError(phoneEl, 'Please add your mobile number so we can reach you about your plan.');
    return;
  }
  skFieldClear(phoneEl);
  /* capture as a Shopify customer → MailChimp (quiz custom-quote lead) */
  skLeadCapture(skAns.cx.email, 'quiz,custom,newsletter');
  /* email the kitchen so the promised quote actually gets sent */
  skNotifyKitchen({ Email: skAns.cx.email, Phone: skQuizPhoneE164(skAns.cx.phone), Route: 'custom quote', Need: skAns.cx.need, Plan: skAns.cx.plan });
  kTrack('quiz_custom_submit', { plan: skAns.cx.plan || '', need: skAns.cx.need || '' });
  skShowScreen('sk-s-customdone');
}

/* ─── DIETARY HELPERS ────────────────────────────────────── */
function skDietList() {
  var parts = skAns.diet.slice();
  if (skAns.dietText) parts.push(skAns.dietText);
  parts = parts.map(function (p) { return p.toLowerCase(); });
  if (!parts.length) return '';
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return parts.join(' and ');
  return parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1];
}

/* ─── RECAP ──────────────────────────────────────────────── */
function skRecapHTML() {
  var items = [];
  if (skAns.routerEcho) items.push({ t: skAns.routerEcho });
  if (skBranch === 'box') {
    if (skAns.tierEcho) items.push({ t: skAns.tierEcho });
    if (skAns.sizeEcho) items.push({ t: skAns.sizeEcho });
  }
  var keep = skDietList();
  if (keep) items.push({ t: "We'll keep " + keep + ' off your plate.', keepoff: true });
  var lis = items.map(function (it) {
    return '<li class="' + (it.keepoff ? 'keepoff' : '') + '"><span class="b">' + (it.keepoff ? xSVG() : checkSVG()) + '</span><span>' + it.t + '</span></li>';
  }).join('');
  return '<div class="sk-recap"><div class="sk-recap-h">Here\'s what you told me</div><ul>' + lis + '</ul></div>';
}

/* ─── EMAIL BLOCK (post-result Klaviyo capture) ──────────── */
/* Email capture is OFF until the MailChimp quiz-welcome journey is built (see the
   "Quiz welcome emails" phase). We don't collect addresses we can't yet act on, and
   we don't promise an email that won't arrive. Flip this to true — nothing else —
   the day the MailChimp automation goes live, and the capture returns everywhere. */
var SK_QUIZ_EMAIL_CAPTURE = false;

function skEmailHTML() {
  if (!SK_QUIZ_EMAIL_CAPTURE) return '';
  return '<div class="sk-email" id="sk-email-block">'
    + '<div class="eh">Want me to send this to you?</div>'
    + '<div class="es">I\'ll email your plan and this week\'s menu, so it\'s there when you\'re ready. No spam, ever.</div>'
    /* Email only — no mobile number here. This block is a "send me the menu" newsletter
       opt-in (note the skip button), not an enquiry, and the owner's rule is that the
       mandatory mobile applies to enquiry forms only. */
    + '<div class="sk-email-row">'
    +   '<input class="sk-field" id="sk-email-input" type="email" inputmode="email" aria-label="Your email address" placeholder="you@email.com">'
    +   '<button type="button" id="sk-email-send">Send it to me</button>'
    + '</div>'
    + '<button type="button" class="skip" id="sk-email-skip">No thanks, I\'ve got it.</button>'
    + '<div class="done-msg" id="sk-email-done"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg>Got it, you\'re on the list.</div>'
    + '</div>';
}

function skWireEmail(resultKey) {
  var send = document.getElementById('sk-email-send');
  var skip = document.getElementById('sk-email-skip');
  var input = document.getElementById('sk-email-input');
  if (!send) return;
  /* Prefill a known email (logged-in customer, or one typed earlier this visit) */
  if (input && !input.value && window.skKnownEmail) { input.value = window.skKnownEmail() || ''; }

  function finish() {
    var block = document.getElementById('sk-email-block');
    if (!block) return;
    var eh = block.querySelector('.eh');
    var es = block.querySelector('.es');
    var row = block.querySelector('.sk-email-row');
    if (eh) eh.style.display = 'none';
    if (es) es.style.display = 'none';
    if (row) row.style.display = 'none';
    if (skip) skip.style.display = 'none';
    var dm = document.getElementById('sk-email-done');
    if (dm) dm.style.display = 'flex';
    block.classList.add('done');
  }

  if (input) {
    input.oninput = function () { skFieldClear(input); };
    input.onkeydown = function (e) { if (e.key === 'Enter') { e.preventDefault(); send.click(); } };
  }
  send.onclick = function () {
    var v = (input.value || '').trim();
    if (!skValidEmail(v)) {
      skFieldError(input, 'That email doesn\'t look right. Mind checking it?', document.querySelector('#sk-email-block .sk-email-row'));
      return;
    }
    skFieldClear(input);
    /* capture as a Shopify customer → MailChimp (quiz result, wants the menu).
       resultKey is the matched tier (lifestyle/performance/recovery) for box results,
       or 'oneoff' for the try-first route — pass the tier through so the quiz welcome
       email can name their match; oneoff has no tier, so send '' (empty merge field). */
    var skTier = (resultKey === 'oneoff') ? '' : resultKey;
    /* Fold the quiz outcome into the tags so each result can trigger its OWN MailChimp
       welcome: tier-lifestyle / tier-performance / tier-recovery, or 'oneoff' for the
       try-first route. Tier still also passes through as the TIER merge field (3rd arg). */
    var skResultTags = skTier ? ('quiz,newsletter,tier-' + skTier) : 'quiz,newsletter,oneoff';
    skLeadCapture(v, skResultTags, skTier);
    kTrack('quiz_email', { result: resultKey });
    finish();
  };
  if (skip) {
    skip.onclick = function () { kTrack('quiz_email', { result: resultKey, skipped: true }); finish(); };
  }
}

/* ─── PRICE HELPERS ──────────────────────────────────────────
   Single source of truth for displayed prices = the JSON island's priceCents
   (wired from the section's Theme-Editor price settings → also what the cart
   charges). Never hand-type prices in this file again or the quiz can drift
   from the real Weekly Box. */
function skQuizMoney(cents, forceDecimals) {
  var d = cents / 100;
  return (!forceDecimals && cents % 100 === 0) ? '$' + d : '$' + d.toFixed(2);
}
function skTierPrice(tierKey, size) {
  var t = skVariantData[tierKey];
  if (!t || !t[size] || !t[size].priceCents) return null;
  var c = t[size].priceCents;
  return { cents: c, weekly: skQuizMoney(c, false), perMeal: skQuizMoney(c / size, true) };
}

/* ─── REFRAME (time-back box) ────────────────────────────── */
function skReframeHTML(tierKey) {
  var r = SK_TIERS[tierKey];
  if (!r.rows) { return '<div class="sk-reframe"><span class="lbl">Two ways in</span><p>' + r.reframe + '</p></div>'; }
  var sv = SK_SIZEVAL[skAns.size] || SK_SIZEVAL[10];
  var p = skTierPrice(tierKey, skAns.size);
  var perMeal = p ? p.perMeal : ((r.rows.filter(function (x) { return x.size === skAns.size; })[0] || r.rows[1]).pm);
  return '<div class="sk-reframe"><span class="lbl">Built-in saving · ~' + sv.hrsShort + ' back a week</span>'
    + '<p>Cooking those ' + skAns.size + ' meals yourself runs about <strong>' + sv.grocery + '</strong> in groceries and <strong>' + sv.hrs + '</strong> of shopping, prep and cleanup, every week. Your ' + skAns.size + '-meal box hands that <strong>' + sv.hrsShort + ' back</strong>, chef made and macro counted at <strong>' + perMeal + ' a meal</strong>.</p></div>';
}

/* Sticky mobile action bar for the result screen — the result is a long scroll in
   the popup, so mirror the primary CTA pinned to the bottom. aria-hidden + tabindex
   -1 so it's a visual duplicate only (the real CTA stays the single a11y action). */
function skResultStickyCTA(label) {
  return '<div class="sk-result-stickcta" aria-hidden="true">'
    + '<button type="button" class="sk-btn-cta" tabindex="-1">' + label + ' ' + arrowSVG() + '</button>'
    + '</div>';
}

/* ─── BOX RESULT ──────────────────────────────────────────── */
function skShowBoxResult() {
  var key = skAns.tier;
  var r = SK_TIERS[key];
  kTrack('quiz_result', { branch: 'box', tier: key });

  var html = '';
  html += '<div class="sk-res-head">'
    + '<span class="sk-badge">Your Match · ' + r.badge + '</span>'
    + '<div class="sk-res-title">' + r.title + '</div>'
    + '<p class="sk-res-desc">' + r.desc + '</p>'
    + '<span class="sk-macros-pill">' + r.macros + '</span>'
    + '</div>';

  html += skRecapHTML();
  html += '<p class="sk-para">' + r.diag + '</p>';

  /* price table (not for custom) — prices read from the live settings via
     skTierPrice(), never hand-typed, so they can't drift from the real box. */
  if (r.rows) {
    html += '<table class="sk-price-table"><thead><tr><th>Meals / week</th><th>Weekly</th><th>Per meal</th></tr></thead><tbody>';
    [15, 10, 5].forEach(function (size) {
      var p = skTierPrice(key, size);
      var fallback = r.rows.filter(function (x) { return x.size === size; })[0];
      if (!p && !fallback) return;
      var weekly = p ? p.weekly : fallback.wk;
      var perMeal = p ? p.perMeal : fallback.pm;
      var cls = [];
      var tags = '';
      if (size === skAns.size) cls.push('sk-yours');
      if (size === 15) { tags += '<span class="sk-tag best">Best value</span>'; }
      else if (size === 10) { tags += '<span class="sk-tag popular">Most popular</span>'; }
      if (size === skAns.size) { tags += '<span class="sk-tag yours">Your pick</span>'; }
      html += '<tr class="' + cls.join(' ') + '"><td>' + size + ' meals' + tags + '</td><td>' + weekly + '</td><td>' + perMeal + '</td></tr>';
    });
    var sv = SK_SIZEVAL[skAns.size] || SK_SIZEVAL[10];
    html += '<tr class="sk-grocery"><td>Cooking it yourself</td><td>' + sv.grocery + '</td><td>+ ' + sv.hrsShort + '</td></tr>';
    html += '</tbody></table>';
    html += '<p class="sk-table-note">The bigger the box, the less each meal costs. <strong>15 lands cheapest per meal</strong>. Most people start at 10.</p>';
  }

  html += skReframeHTML(key);

  /* dietary reassurance */
  var keep = skDietList();
  if (keep) { html += '<div class="sk-reassure">And don\'t stress, we\'ll keep <b>' + keep + '</b> off your plate.</div>'; }

  /* CTAs — links, same tab */
  if (key === 'custom') {
    html += '<div class="sk-cta-wrap">'
      + '<a href="' + SK_URL.custom + '" class="sk-btn-cta" data-cta="custom">Get a custom quote, free ' + arrowSVG() + '</a>'
      + '<a href="' + SK_URL.contact + '" class="sk-btn-sec" data-cta="contact">Tell me more about the standard plans</a>'
      + '</div>';
  } else {
    /* Box CTA → the Weekly Box PDP, pre-selected to the quiz answers.
       The PDP reads ?tier & ?size (sk-weekly-box.liquid:41,500-502) to open on
       the right plan + size; the allergy/avoid picks ride along in cart.attributes
       (stashed on click) so the PDP's allergy card pre-ticks them and they carry
       through to Recharge + the customer profile. Customer reviews, then adds. */
    /* view=weekly-box forces the full Weekly Box template (tier/size deep-link +
       allergy card) even before the product's template_suffix is assigned at launch;
       it's a harmless override once the suffix IS assigned. */
    var boxUrl = SK_URL.box + '?view=weekly-box&tier=' + encodeURIComponent(key) + '&size=' + skAns.size;
    html += '<div class="sk-cta-wrap">'
      + '<a href="' + boxUrl + '" class="sk-btn-cta" data-cta="box" data-box-go="' + boxUrl + '">Set up my ' + skAns.size + '-meal box ' + arrowSVG() + '</a>'
      + '<a href="' + SK_URL.contact + '" class="sk-btn-sec" data-cta="contact">Not sure yet? Chat to us first</a>'
      + '</div>';
  }

  html += skEmailHTML();
  html += '<button type="button" class="sk-btn-restart" id="sk-result-restart">Retake the quiz</button>';
  if (key !== 'custom') { html += skResultStickyCTA('Set up my ' + skAns.size + '-meal box'); }

  var rc = document.getElementById('sk-result-card');
  rc.innerHTML = html;
  rc.setAttribute('data-tier', key); /* tints the reveal (badge/title/buttons/accents) to the matched tier */
  skWireResultButtons(key);
  skShowScreen('sk-s-result');
}

/* ─── ONE-OFF RESULT ──────────────────────────────────────── */
function skShowOneoffResult() {
  kTrack('quiz_result', { branch: 'oneoff' });
  var html = '';
  html += '<div class="sk-res-head">'
    + '<span class="sk-badge">Your Match · This Week\'s Menu</span>'
    + '<div class="sk-res-title">Start with <em>this week\'s menu.</em></div>'
    + '<p class="sk-res-desc">No commitment, no lock-in. The fastest way to know if this is for you is to taste it.</p>'
    + '</div>';
  html += skRecapHTML();
  html += '<p class="sk-para"><strong>You don\'t want a commitment, you want proof. Fair enough.</strong> Here\'s exactly what\'s on the menu this week. Pick a few, see how they land.</p>';

  var keep = skDietList();
  if (keep) { html += '<div class="sk-reassure">And don\'t stress, we\'ll keep <b>' + keep + '</b> off your plate.</div>'; }

  html += '<div class="sk-cta-wrap">'
    + '<a href="' + SK_URL.oneoff + '" class="sk-btn-cta" data-cta="oneoff">See this week\'s menu ' + arrowSVG() + '</a>'
    + '</div>';
  html += skEmailHTML();
  html += '<button type="button" class="sk-btn-restart" id="sk-result-restart">Retake the quiz</button>';
  html += skResultStickyCTA('See this week\'s menu');

  var rc = document.getElementById('sk-result-card');
  rc.innerHTML = html;
  rc.removeAttribute('data-tier'); /* one-off has no tier → stays the default green */
  skWireResultButtons('oneoff');
  skShowScreen('sk-s-result');
}

/* ─── WIRE RESULT BUTTONS ─────────────────────────────────── */
function skWireResultButtons(resultKey) {
  /* track CTA clicks */
  document.querySelectorAll('#sk-result-card [data-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      kTrack('quiz_cta_click', { cta: el.getAttribute('data-cta'), result: resultKey });
    });
  });

  /* sticky mobile CTA mirrors the primary action (forwards the click) */
  var stickyBtn = document.querySelector('#sk-result-card .sk-result-stickcta button');
  var primaryCta = document.querySelector('#sk-result-card .sk-cta-wrap .sk-btn-cta');
  if (stickyBtn && primaryCta) { stickyBtn.onclick = function () { primaryCta.click(); }; }

  /* The pinned copy only earns its place when the real CTA has scrolled out of view.
     A near-full result can overflow by a few pixels while the inline CTA is still
     visible — in that case the pinned copy would sit right under it and look like a
     duplicate button. Watch the inline CTA: while it's on screen, hide the pinned
     copy; once it scrolls off, reveal it (revert to the CSS default = block on
     mobile, none elsewhere). */
  var stickyWrap = document.querySelector('#sk-result-card .sk-result-stickcta');
  var popupScroller = document.getElementById('sk-quiz-popup');
  if (stickyWrap && primaryCta && popupScroller && 'IntersectionObserver' in window) {
    stickyWrap.style.display = 'none';
    var stickyObserver = new IntersectionObserver(function (entries) {
      stickyWrap.style.display = entries[0].isIntersecting ? 'none' : '';
    }, { root: popupScroller, threshold: 0.6 });
    stickyObserver.observe(primaryCta);
  }

  /* Scroll nudge for long results (the box tiers): a gentle down-chevron shown only
     while the result overflows AND the reader is still at the top, so it's clear
     there's a price table + CTA below. It dismisses on the first scroll so it never
     nags, handing over to the pinned CTA as the persistent action. */
  var resultCard = document.getElementById('sk-result-card');
  if (resultCard && popupScroller) {
    var cue = document.createElement('div');
    cue.className = 'sk-scroll-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    resultCard.appendChild(cue);
    var cueDismissed = false;
    var updateCue = function () {
      var overflow = popupScroller.scrollHeight - popupScroller.clientHeight;
      cue.classList.toggle('is-visible', !cueDismissed && overflow > 24 && popupScroller.scrollTop < 8);
    };
    popupScroller.addEventListener('scroll', function () {
      if (popupScroller.scrollTop > 8) cueDismissed = true;
      updateCue();
    }, { passive: true });
    window.addEventListener('resize', updateCue);
    requestAnimationFrame(updateCue);
  }

  /* box CTA → stash the quiz's allergy/avoid/gift picks into cart.attributes,
     then open the Weekly Box PDP pre-selected to the chosen tier + size. The PDP
     reviews + adds; the stashed attributes pre-tick its allergy card and carry to
     Recharge + the customer profile (same path the cart-extras card uses). */
  var boxGoEl = document.querySelector('#sk-result-card [data-box-go]');
  if (boxGoEl) {
    boxGoEl.addEventListener('click', function (e) {
      e.preventDefault();
      if (boxGoEl._busy) return;
      boxGoEl._busy = true;
      /* loading feedback — the stash POST then navigation can lag on slow connections */
      boxGoEl.setAttribute('aria-busy', 'true');
      boxGoEl.style.pointerEvents = 'none';
      boxGoEl.style.opacity = '0.75';
      boxGoEl.textContent = 'Setting up your box…';
      kTrack('quiz_add_to_cart', { tier: skAns.tier, size: skAns.size, gift: skGift ? 1 : 0, dest: 'pdp' });
      skStashExtrasThenGo(boxGoEl.getAttribute('data-box-go') || SK_URL.box);
    });
  }

  /* gift checkbox */
  var gift = document.getElementById('sk-gift');
  if (gift) {
    function toggleGift() {
      skGift = !skGift;
      gift.classList.toggle('on', skGift);
      gift.setAttribute('aria-checked', skGift ? 'true' : 'false');
    }
    gift.onclick = toggleGift;
    gift.onkeydown = function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleGift(); } };
  }

  /* restart button (inside result card) */
  var restart = document.getElementById('sk-result-restart');
  if (restart) { restart.onclick = skRestartQuiz; }

  skWireEmail(resultKey);
}

/* ─── DIETARY → result router ────────────────────────────── */
function skDietNext() {
  skAns.dietText = (document.getElementById('sk-diet-text').value || '').trim();
  if (skBranch === 'box') skShowBoxResult(); else skShowOneoffResult();
}
function skDietNone() {
  skAns.diet = []; skAns.dietText = '';
  if (skBranch === 'box') skShowBoxResult(); else skShowOneoffResult();
}

/* ─── OPEN / CLOSE / RESET / RESTART ────────────────────────*/
/* Move keyboard focus to the first usable control inside the open popup, so
   keyboard + screen-reader users land inside the dialog (not behind it). */
function skFocusFirst() {
  var popup = document.getElementById('sk-quiz-popup');
  if (!popup) return;
  var f = popup.querySelector('.sk-screen.active button:not([disabled]):not(.hide), .sk-screen.active input, .sk-screen.active textarea, .sk-screen.active [tabindex]:not([tabindex="-1"])');
  if (f) { setTimeout(function () { f.focus({ preventScroll: true }); }, 60); }
}
function skOpenQuiz() {
  var overlay = document.getElementById('sk-quiz-overlay');
  var tab = document.getElementById('sk-sticky-tab');
  skLastFocus = document.activeElement;   /* remember what to return focus to */
  if (overlay) { overlay.classList.add('active'); document.body.style.overflow = 'hidden'; }
  if (tab) tab.classList.remove('visible');
  skFocusFirst();
  kTrack('quiz_opened', { trigger: 'manual' });
}
function skCloseQuiz() {
  var overlay = document.getElementById('sk-quiz-overlay');
  var tab = document.getElementById('sk-sticky-tab');
  if (overlay) overlay.classList.remove('active');
  if (tab) tab.classList.add('visible');
  document.body.style.overflow = '';
  /* return focus to whatever opened the popup (the trigger button/link) */
  if (skLastFocus && typeof skLastFocus.focus === 'function') {
    try { skLastFocus.focus({ preventScroll: true }); } catch (x) {}
  }
  skLastFocus = null;
  kTrack('quiz_dismissed', { branch: skBranch || 'none' });
}
function skResetState() {
  skBranch = null; skScreen = 'router'; skCfIndex = 0; skGift = false;
  skAns = { router: null, tier: null, size: null, diet: [], dietText: '', cf: { outcome: '', blocker: '', timing: null, email: '', phone: '' }, cx: { need: '', plan: null, email: '', phone: '' } };
}
function skRestartQuiz() {
  skResetState();
  var closeBtn = document.getElementById('sk-close-btn');
  if (closeBtn) closeBtn.classList.remove('show');
  skShowScreen('sk-s-entry');
}
function skDismiss() {
  skCloseQuiz();
  try { sessionStorage.setItem(SK_DISMISS_KEY, '1'); } catch (x) {}
  kTrack('quiz_dismissed', { reason: 'just_browsing' });
}

/* ─── VARIANT DATA (from JSON island) ───────────────────────*/
var skVariantData = {};
var skSellingPlanId = null;   /* Recharge selling plan (subscription) */
var skGiftVariantId = null;   /* $0 "free Recovery Pot" gift variant, if created */
var skCartUrl = '/cart';
(function () {
  var el = document.getElementById('sk-quiz-variants');
  if (!el) return;
  try {
    var d = JSON.parse(el.textContent);
    ['lifestyle', 'performance', 'recovery'].forEach(function (k) {
      if (d[k]) skVariantData[k] = d[k];
    });
    if (d.custom && d.custom.url) SK_URL.custom = d.custom.url;
    if (d.sellingPlanId) skSellingPlanId = d.sellingPlanId;
    if (d.giftVariantId) skGiftVariantId = d.giftVariantId;
    if (d.cartUrl) skCartUrl = d.cartUrl;
    /* canonical allergen list (single source: sk_allergen_list theme setting) */
    if (d.allergens) {
      var _al = String(d.allergens).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (_al.length) SK_DIET = _al;
    }
  } catch (x) {}
})();

/* ─── ADD TO CART (box result) ──────────────────────────────*/
function skCartAdd(item) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(item)
  }).then(function (r) {
    if (!r.ok) { return r.json().then(function (d) { throw d; }); }
    return r.json();
  });
}

/* Stash the quiz's allergy / foods-to-avoid / gift picks onto the cart as
   attributes, then navigate to the pre-selected Weekly Box PDP. cart.attributes
   persist on an empty cart, so the PDP's allergy card (which reads
   cart.attributes['Allergies']) opens pre-ticked, and on add-to-cart there the
   picks become line properties → Recharge recurrence + (via Flow) the customer
   profile. Always navigates, even if the stash request fails. */
function skStashExtrasThenGo(url) {
  var attrs = {};
  if (skAns.diet && skAns.diet.length) attrs['Allergies'] = skAns.diet.join(', ');
  if (skAns.dietText) attrs['Foods to avoid'] = skAns.dietText;
  if (skGift) attrs['First box gift'] = 'Free Recovery Pot';
  if (!Object.keys(attrs).length) { window.location.href = url; return; }
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs })
  })
    .then(function () { window.location.href = url; })
    .catch(function () { window.location.href = url; });
}

/* NOTE: skBoxAddToCart is retained but no longer wired (the box CTA now routes
   to the PDP via skStashExtrasThenGo). Kept for reference / quick revert. */
function skBoxAddToCart(el) {
  if (el._busy) return;
  var key = skAns.tier;
  var vd = (skVariantData[key] && skVariantData[key][skAns.size]) ? skVariantData[key][skAns.size] : null;
  var fallback = el.getAttribute('href') || SK_URL.box;
  if (!vd || !vd.variantId) { window.location.href = fallback; return; }

  el._busy = true;
  el.setAttribute('aria-busy', 'true');
  el.style.pointerEvents = 'none';
  el.style.opacity = '0.75';
  el.textContent = 'Adding to your cart…';

  var boxItem = { id: vd.variantId, quantity: 1 };
  if (SK_BOX_AS_SUBSCRIPTION && skSellingPlanId) { boxItem.selling_plan = skSellingPlanId; }
  /* Free pot ticked but no $0 gift product configured yet → leave a note
     on the box so the kitchen still adds it to the first box. */
  if (skGift && !skGiftVariantId) {
    boxItem.properties = { 'Free Recovery Pot': 'Yes please, add to my first box' };
  }

  kTrack('quiz_add_to_cart', { tier: key, size: skAns.size, gift: skGift ? 1 : 0 });

  skCartAdd(boxItem).then(function () {
    if (skGift && skGiftVariantId) {
      /* add the free pot as its own line — best effort, never blocks the box */
      return skCartAdd({ id: skGiftVariantId, quantity: 1, properties: { 'Gift': 'Free Recovery Pot with first box' } }).catch(function () {});
    }
  }).then(function () {
    window.location.href = skCartUrl || '/cart';
  }).catch(function () {
    /* box add failed → fall back to the product page */
    window.location.href = fallback;
  });
}

/* ─── POPUP TRIGGERS ────────────────────────────────────────*/
function skTriggerPopup(reason) {
  if (!window.SK_QUIZ_POPUP_ENABLED) return;   // auto-open (timer/exit-intent) is homepage-only
  if (skSessionShown) return;
  try { if (sessionStorage.getItem(SK_DISMISS_KEY)) return; } catch (x) {}
  skSessionShown = true;
  var overlay = document.getElementById('sk-quiz-overlay');
  if (!overlay) return;
  skLastFocus = document.activeElement;
  overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
  skFocusFirst();
  kTrack('quiz_opened', { trigger: reason });
}

/* ─── INIT (idempotent) ─────────────────────────────────────*/
var skInitDone = false;
function skInit() {
  if (skInitDone) return;
  skInitDone = true;

  var overlay = document.getElementById('sk-quiz-overlay');
  var tab = document.getElementById('sk-sticky-tab');
  var startBtn = document.getElementById('sk-start-btn');
  var browsingBtn = document.getElementById('sk-browsing-btn');
  var btnBack = document.getElementById('sk-btn-back');
  var dietNext = document.getElementById('sk-diet-next');
  var dietNone = document.getElementById('sk-diet-none');
  var dietBack = document.getElementById('sk-diet-back');
  var cfNext = document.getElementById('sk-cf-next');
  var cfBack = document.getElementById('sk-cf-back');
  var cxSubmit = document.getElementById('sk-cx-submit');
  var cxBack = document.getElementById('sk-cx-back');
  var closeBtn = document.getElementById('sk-close-btn');
  var coachDoneRestart = document.getElementById('sk-coachdone-restart');
  var customDoneRestart = document.getElementById('sk-customdone-restart');

  if (startBtn) {
    startBtn.addEventListener('click', function () {
      if (closeBtn) closeBtn.classList.add('show');
      skResetState();
      skRenderQuiz();
      kTrack('quiz_started', {});
    });
  }
  if (browsingBtn) browsingBtn.addEventListener('click', skDismiss);
  if (btnBack) btnBack.addEventListener('click', skQuizBack);
  if (dietNext) dietNext.addEventListener('click', skDietNext);
  if (dietNone) dietNone.addEventListener('click', skDietNone);
  if (dietBack) dietBack.addEventListener('click', skDietBack);
  if (cfNext) cfNext.addEventListener('click', skCoachNext);
  if (cfBack) cfBack.addEventListener('click', skCoachBack);
  if (cxSubmit) cxSubmit.addEventListener('click', skSubmitCustom);
  if (cxBack) cxBack.addEventListener('click', function () { skScreen = 'tier'; skRenderQuiz(); });
  if (closeBtn) closeBtn.addEventListener('click', skCloseQuiz);
  if (coachDoneRestart) coachDoneRestart.addEventListener('click', skRestartQuiz);
  if (customDoneRestart) customDoneRestart.addEventListener('click', skRestartQuiz);

  /* Overlay backdrop click */
  if (overlay) {
    overlay.addEventListener('click', function (e) { if (e.target === overlay) skCloseQuiz(); });
  }

  /* Sticky tab */
  if (tab) {
    tab.addEventListener('click', skOpenQuiz);
    tab.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); skOpenQuiz(); } });
  }

  /* Manual quiz triggers — any link/button on the page that should open the
     popup instead of navigating: data-sk-quiz-open, #quiz anchors, or legacy
     /pages/start-here links. Only active where the popup exists (homepage). */
  if (overlay) {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sk-quiz-open], a[href="#quiz"], a[href$="/pages/start-here"]');
      if (!t) return;
      e.preventDefault();
      skOpenQuiz();
    });
  }

  /* Esc key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('active')) skCloseQuiz();
  });

  /* Focus trap (popup only). The sentinels are siblings of the card, inside the
     overlay — so query the OVERLAY for them, but keep the focusable list scoped
     to the card itself. */
  var popup = document.getElementById('sk-quiz-popup');
  if (popup && overlay) {
    var sentStart = overlay.querySelector('[data-focus-sentinel-start]');
    var sentEnd = overlay.querySelector('[data-focus-sentinel-end]');
    if (sentStart && sentEnd) {
      sentStart.addEventListener('focus', function () {
        var focusable = popup.querySelectorAll('button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])');
        var last = focusable[focusable.length - 1];
        if (last) last.focus();
      });
      sentEnd.addEventListener('focus', function () {
        var focusable = popup.querySelectorAll('button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])');
        if (focusable[0]) focusable[0].focus();
      });
    }
  }

  /* Popup triggers */
  if (overlay) {
    /* Only trigger: fire once the visitor has scrolled PAST the plans section
       (#plans, homepage only). No timer fallback — pages without #plans just
       never auto-open the popup. */
    var plans = document.getElementById('plans');
    if (plans && 'IntersectionObserver' in window) {
      var plansObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          /* not intersecting + scrolled above the viewport = past the plans */
          if (!en.isIntersecting && en.boundingClientRect.bottom < 0) {
            skTriggerPopup('scroll_past_plans');
            plansObs.disconnect();
          }
        });
      }, { threshold: 0 });
      plansObs.observe(plans);
    }
    if (SK_EXIT_INTENT) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 0) skTriggerPopup('exit_intent');
      });
    }
  }
}

/* Run after DOM ready */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', skInit);
} else {
  skInit();
}
